export default __webpack_public_path__ + "static/media/oscer-pres-groin-swelling.a6498d89.svg";